import { Action, createReducer, on } from '@ngrx/store';
import { ChartHistory, MarketFeed, MarketPrice } from '../../models/market.model';
import * as InsightActions from '../actions/insight.action';
import { LiveBalanceResponse } from '../../models/live-balance.model';
import { TickerFeed } from '../../models/ticker.model';
import { ManualStock } from '../../models/manual-stock.model';

const REFRESHING_BALANCES_INTERVAL = 5000;

export interface State {
  marketFeed: MarketFeed;
  tickerFeed: TickerFeed;
  chartHistory: ChartHistory;
  liveBalances: LiveBalanceResponse;
  portfolioValue: number;
  manualStocks: ManualStock[];
  acquisitionPrices: Map<string, any>;
  refreshingBalances: boolean;
}

export const initialState: State = {
  marketFeed: null,
  tickerFeed: null,
  chartHistory: null,
  liveBalances: null,
  portfolioValue: null,
  manualStocks: null,
  acquisitionPrices: null,
  refreshingBalances: false,
};

const reducer = createReducer(
  initialState,
  on(InsightActions.setPortfolioValueAction, (state: State, { portfolioValue }: any) => ({
    ...state,
    portfolioValue,
  })),
  on(InsightActions.setMarketFeedAction, (state: State, { marketFeed }: any) => {
    const priceMap: Map<string, MarketPrice> = new Map(
      state.marketFeed?.marketFeed?.map((marketPrice: MarketPrice) => [marketPrice.symbol, marketPrice]),
    );

    marketFeed.marketFeed.forEach((marketPrice: MarketPrice) => priceMap.set(marketPrice.symbol, marketPrice));

    return {
      ...state,
      marketFeed: {
        ...marketFeed,
        marketFeed: Array.from(priceMap.values()),
      },
    };
  }),
  on(InsightActions.setTickerFeedAction, (state: State, { tickerFeed }: any) => ({
    ...state,
    tickerFeed,
  })),
  on(InsightActions.setLiveBalancesAction, (state: State, { liveBalances, force }: any) => ({
    ...state,
    liveBalances,
    refreshingBalances: force || liveBalances?.retryIn <= REFRESHING_BALANCES_INTERVAL,
  })),
  on(InsightActions.setManualStocksAction, (state: State, { manualStocks }: any) => ({
    ...state,
    manualStocks,
  })),
  on(InsightActions.setAcquisitionPricesAction, (state: State, { acquisitionPrices }: any) => ({
    ...state,
    acquisitionPrices,
  })),
  on(InsightActions.loadChartHistoryAction, (state: State) => ({
    ...state,
    refreshingBalances: true,
  })),
  on(InsightActions.setChartHistoryAction, (state: State, { chartHistory }: any) => ({
    ...state,
    chartHistory,
  })),
);

export const insightReducer = (state: State | undefined, action: Action): State => reducer(state, action);
